import { render } from "./overview-current.vue?vue&type=template&id=747ffcd8"
import script from "./overview-current.vue?vue&type=script&lang=js"
export * from "./overview-current.vue?vue&type=script&lang=js"

import "./overview-current.vue?vue&type=style&index=0&id=747ffcd8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__